<template>
  <div>
    <!-- <van-notice-bar left-icon="volume-o" text="尊敬的客户：您好，由于疫情原因，部分区域物流暂时无法发出，如兑换商品7天未查到物流信息，请拨打4001891892查询。给您带来不便，敬请谅解！" />
    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
      <van-swipe-item v-for=" item in swipeImgUrl" v-bind:key="item">
        <van-image lazy-load height="200px" fit="fill" width="100%" :src="item" />
      </van-swipe-item>
    </van-swipe>
    <van-divider>商品类别</van-divider>
    <van-grid :border="true" :column-num="3">
      <van-grid-item v-for="(item,idx) in categoryList" v-bind:key="idx"
        :to="{ name: 'GoodList', params: { categoryId: item.ID }}">
        <div>
          <van-image height="80px" width="100px" :src="item.CategoryImg" />
          <p class="categorydesc">{{item.CategoryName}}</p>
        </div>
      </van-grid-item>
    </van-grid>
    <van-divider>精选推荐</van-divider>
    <div v-for="(data,idx) in goodsCategoryList" v-bind:key="idx">

      <van-image class="my-swipe" :src="data.GoodsCategory.GoodsImg" fit="contain"></van-image>
      <van-grid :border="false" :column-num="2" :gutter="9">
        <van-grid-item v-for="(item,idx) in data.GoodList" v-bind:key="idx">
          <goodGrid :goodName="item.GoodsName" :price="item.UnitPrice" :id="item.ID" :imgUrl="item.GoodsImg"></goodGrid>
        </van-grid-item>
      </van-grid>
    </div> -->
    <img src="../assets/draw2026/index_bg.png" fit="contain" width="100%" alt="" />
    <!-- <img src="../assets/draw2023/main_bg.jpg" fit="contain" width="100%" alt="" /> -->
    <!-- <div style="text-align:center;margin-top:-36%;">
      <img style="width:257px;height:48px;" class="image" src="../assets/draw2023/main_btn.png" @click="toActivity()">
    </div> -->
  </div>
</template>

<script>
// import { Swipe, SwipeItem } from "vant";
// import { Grid, GridItem } from "vant";
// import { Divider } from "vant";
// import goodGrid from "../components/goodGird";
import wx from "weixin-js-sdk";
export default {
  name: "Index",
  data() {
    return {
      fileUrl: this.$file.url,
      swipeImgUrl: [],
      categoryList: [{ CategoryName: "", CategoryImg: "" }],
      goodList: [],
      goodsCategoryList: [],
    };
  },
  components: {
    // [Swipe.name]: Swipe,
    // [SwipeItem.name]: SwipeItem,
    // [Grid.name]: Grid,
    // [GridItem.name]: GridItem,
    // [Divider.name]: Divider,
    // goodGrid,
  },
  mounted() {
    this.wxconfig();
    this.GetData();
  },
  computed: {
    isLogined() {
      return this.$store.state.isLogin;
    },
  },
  methods: {
    wxconfig: function () {
      var that = this;
      var url = encodeURIComponent(location.href.split("#")[0]);      
      // url=encodeURIComponent("https://sale.reaca.net")
      this.$http.get("WeChatApi/GetJSConfig?url=" + url).then((response) => {
        console.log(response);
        wx.config({
          debug: false,
          appId: response.data.Data.appId,
          timestamp: parseInt(response.data.Data.timestamp),
          nonceStr: response.data.Data.noncestr,
          signature: response.data.Data.sign,
          jsApiList: ["updateAppMessageShareData", "updateTimelineShareData","onMenuShareAppMessage"],
        });

        wx.ready(function () {
          wx.updateAppMessageShareData({
            title: '天力管', // 分享标题
            desc: "天力管水电工程师活动中心", // 分享描述
            link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
            imgUrl: "https://oss.reaca.net/webPic/vr_logo.png", // require("../../assets/vr_logo.png"), // 分享图标
            success: function () {
              console.log("success");
              // 设置成功
            },
          });
          wx.updateTimelineShareData({
            title: '天力管', // 分享标题
            link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
            imgUrl: "https://oss.reaca.net/webPic/vr_logo.png", //require("../../assets/vr_logo.png"), // 分享图标
            success: function () {
              console.log("success");              
            },
          });
          wx.onMenuShareAppMessage({
            title: '天力管', // 分享标题
            link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
            imgUrl: "https://oss.reaca.net/webPic/vr_logo.png", //require("../../assets/vr_logo.png"), // 分享图标
            success: function () {
              console.log("success");              
            },
          });
        });
        // that.LoadImg(res);
      });
    },
    GetData() {
      var that = this;
      this.$http.get("Order/GetMallIndexImg").then((res) => {
        if (res.data.Data != "" && res.data.Data.length > 0) {
          for (let i = 0; i < res.data.Data.length; i++) {
            const el = res.data.Data[i];
            that.swipeImgUrl.push(that.$file.url + el);
          }
        }
      });
      this.$http.get("Order/GetMallIndexCategory?isAll=0").then((res) => {
        var datalist = [];
        if (res.data.Data.length > 0) {
          for (let x = 0; x < res.data.Data.length; x++) {
            var el = res.data.Data[x];
            el.CategoryImg =
              that.$file.url +
              "Images/Mall/Category/" +
              res.data.Data[x].CategoryImg;
            datalist.push(el);
          }

          that.categoryList = datalist;
        }
      });
      this.$http.get("Order/GetMallIndexGoodsForH5").then((res) => {
        var data = res.data.Data;
        for (let i = 0; i < data.length; i++) {
          if (data[i].GoodsCategory.GoodsImg != null) {
            data[i].GoodsCategory.GoodsImg =
              that.$file.url +
              "Images/Mall/Category/" +
              data[i].GoodsCategory.GoodsImg;
          }
          //商品图片路径处理
          for (let x = 0; x < data[i].GoodList.length; x++) {
            if (data[i].GoodList[x].GoodsImg != null) {
              if (data[i].GoodList[x].GoodsImg.length > 0) {
                data[i].GoodList[x].GoodsImg =
                  that.$file.url +
                  "Images/Mall/GoodsImg/" +
                  data[i].GoodList[x].GoodsCode +
                  "/" +
                  data[i].GoodList[x].GoodsImg;
                data[i].GoodList[x].UnitPrice = toDecimal2(
                  data[i].GoodList[x].UnitPrice
                );
              }
            }
          }
        }
        that.goodsCategoryList = res.data.Data;
        that.$toast.clear();
      });
    },
    toActivity() {
      if (!this.isLogined) {
        return this.$toast.fail("您还未登录");
      }
      this.$router.push({
        name: "activity2023",
        params: {},
      });
    },
    ViewDetail(id) {
      console.log(id);
    },
  },
};

function toDecimal2(x) {
  var f = parseFloat(x);
  if (isNaN(f)) {
    return false;
  }
  var f = Math.round(x * 100) / 100;
  var s = f.toString();
  var rs = s.indexOf(".");
  if (rs < 0) {
    rs = s.length;
    s += ".";
  }
  while (s.length <= rs + 2) {
    s += "0";
  }
  return s;
}
</script>

<style>
.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  line-height: 150px;
  text-align: center;
  height: 200px;
}
.my-swipe {
  width: 100%;;
}
.goodlist {
  width: 100%;
  display: flex;
  justify-items: center;
  justify-content: space-between;
}
.categorydesc {
  font-size: 14px;
  margin: 0px;
  margin-top: 5px;
}
</style>